import UsersManagersRequest from "../ws/UsersManagersRequest";

export const USER_ADMIN_COPY_COMPANIES_SET_USER = 'user-admin-copy-companies-set-user';
export const USER_ADMIN_COPY_COMPANIES_USERS = 'user-admin-copy-companies-users';
export const USER_ADMIN_COPY_COMPANIES_LOADING = 'user-admin-copy-companies-loading';
export const USER_ADMIN_COPY_COMPANIES_SELECTED_COMPANY = 'user-admin-copy-companies-selected-company';
export const USER_ADMIN_COPY_COMPANIES_UNSELECTED_COMPANY = 'user-admin-copy-companies-unselected-company';
export const USER_ADMIN_COPY_COMPANIES_SELECTED_ALL = 'user-admin-copy-companies-selected-all';
export const USER_ADMIN_COPY_COMPANIES_UNSELECTED_ALL = 'user-admin-copy-companies-unselected-all';
export const USER_ADMIN_COPY_COMPANIES_CLEAR = 'user-admin-copy-companies-clear';

export const setUser = (user) => ({
  type: USER_ADMIN_COPY_COMPANIES_SET_USER,
  payload: user,
});

export const addSelectedCompanyId = (companyId) => ({
  type: USER_ADMIN_COPY_COMPANIES_SELECTED_COMPANY,
  payload: companyId,
});

export const removeSelectedCompanyId = (companyId) => ({
  type: USER_ADMIN_COPY_COMPANIES_UNSELECTED_COMPANY,
  payload: companyId,
});

export const selectedAll = (ids) => ({
  type: USER_ADMIN_COPY_COMPANIES_SELECTED_ALL,
  payload: ids,
});

export const unselectedAll = () => ({
  type: USER_ADMIN_COPY_COMPANIES_UNSELECTED_ALL,
});

export const clear = () => ({
  type: USER_ADMIN_COPY_COMPANIES_CLEAR,
});

export const getUsers = () => (dispatch) => {

  new UsersManagersRequest()
    .onPreExecution(() => {
      dispatch({ type: USER_ADMIN_COPY_COMPANIES_LOADING, payload: true });
    })
    .onSuccess(data => {
      // Enviamos los datos a redux
      dispatch({
        type: USER_ADMIN_COPY_COMPANIES_USERS,
        payload: data.data,
      });
    })
    .onPostExecution(() => {
      dispatch({ type: USER_ADMIN_COPY_COMPANIES_LOADING, payload: false });
    })
    .execute();
};



// WEBPACK FOOTER //
// ./src/app/users/actions/userAdminCopyCompaniesActions.js